import { IUpdateGestaoDistribuicaoEpiUseCase } from "../../../presentation/useCases/update/update_gestao_distribuicao_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class UpdateGestaoDistribuicaoEpiUseCase implements IUpdateGestaoDistribuicaoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {}

  async updateGestaoDistribuicaoEpi(
    idGestaoDistriuicaoEpi: number,
    itens: { idGestaoRecebimentoEpi: number; quantidade: number }[],
    idFuncionario: number | null,
    dataEntrega: Date | null,
    idCentroCustoSaida?: number | null,
    idCentroCusto?: number | null,
  ): Promise<void> {
    await this.repository.updateGestaoDistribuicaoEpi(
      idGestaoDistriuicaoEpi,
      itens,
      idFuncionario,
      dataEntrega,
      idCentroCustoSaida,
      idCentroCusto,
    );
  }
}
